import { render } from "./register-2.vue?vue&type=template&id=83186cbc&scoped=true"
import script from "./register-2.vue?vue&type=script&lang=js"
export * from "./register-2.vue?vue&type=script&lang=js"

import "./register-2.vue?vue&type=style&index=0&id=83186cbc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83186cbc"]])

export default __exports__